export const translatedWorkRelation: { [key: string]: string } = {
  OTHER: 'Não especificado',
  EMPLOYEE: 'Empregado',
  PARTNER: 'Sócio',
  MANAGER: 'Administrador',
  PROXY: 'Procurador',
};
